export default "__VITE_ASSET__3914439c__"